import "./ProfileClaimsSummary.css";
import { Card, CardTitle } from "../../common";
import ProfileClaimsBrowser from "../ProfileClaimsBrowser";
import { useAppState } from "../../../utils/appState";

export default function ProfileClaimsSummary({ count }) {
  const [, setAppState] = useAppState();
  return (
    <Card className="dashboard-report">
      <CardTitle title={"PROFILE CLAIMS"} />
      <div className="dashboard-report__body">
        <div className="dashboard-report__body__blurb">
          There are <span className="bold">{count}</span> profile claims pending
          review.
        </div>

        {!!count && (
          <div
            className="dashboard-report__body__link"
            onClick={() => {
              setAppState({ modal: <ProfileClaimsBrowser /> });
            }}
          >
            View profile claims
          </div>
        )}
      </div>
    </Card>
  );
}
